module.exports = __webpack_public_path__ + "static/media/experiencepro.a4c0974e.png";